import React from 'react';
import { CTAButton } from './CTAButton';
export function MidPageCTA() {
  return <section className="bg-gold-accent py-[80px] px-[40px] text-center" data-id="element-369">
      <div className="max-w-[700px] mx-auto" data-id="element-370">
        <h2 className="font-serif italic text-[32px] md:text-[36px] text-primary-dark mb-5 leading-tight" data-id="element-371">
          One call. One script.
          <br data-id="element-372" />
          Money back in your pocket today.
        </h2>
        <p className="font-sans text-[17px] text-primary-dark max-w-[500px] mx-auto mb-8 leading-relaxed" data-id="element-373">
          David, Carlos, and Maria didn't have special skills.
          <br data-id="element-374" />
          They had a script. And they read it out loud.
        </p>
        <CTAButton subText="Instant download · Make your first call tonight" data-id="element-375">
          I WANT TO MAKE THAT CALL — $9.99
        </CTAButton>
      </div>
    </section>;
}